import React from "react";
import { Col, Row } from "reactstrap";
import { baseUrl, isNovium, isB2C } from "../libs/env";
import { Exitbtn } from "../components/buttons/exitbtn";
import { Header } from "../components/header/header";


const Error = ({ isLoaded, data,  }) => {
  let student = "student" ;
  if(window.location.origin.includes(isNovium) || isB2C.some(domain => window.location.origin.includes(domain)))
  {
    student = "user";
  }
  if (!isLoaded)
    return <h1 className="text-center">Loading...</h1>;
  return (
    <div className="dashboard-wrapper bg-white">
      <div class="container quiz-background">
       
            <Row className="d-none">
              <Col className="text-center">
                <Header />
              </Col>
          </Row>
          <Row>
              <Col className="text-center mt-5">
                {data && data.detail === "Not found." ?
                (<h5>This Exercise Currently Unavailable.</h5>)
                :
                (<h5>Please activate your account to view {student} results.</h5>)
              }
              </Col>
          </Row>
          <Row>
              <Col className="text-center my-5">
              <Exitbtn href={baseUrl} />
              </Col>
          </Row>
      </div>
    </div>
  );
};

export default Error;
